<template>
  <div class="card">
    <div class="order-details">
      <h2>Order from {{ orderDetails.userLocation }}</h2>
      <h3>Restaurant : {{ orderDetails.restaurantLocation }}</h3>
    </div>
    <div class="response">
      <button class="view-details-button" @click="showOrderDetails">
        View Details
      </button>
      &nbsp;
      <button class="accept-order-button" @click="acceptOrder">
        Accept Order
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["orderDetails"],
  methods: {
    showOrderDetails() {
      this.$emit("showOrderDetails", this.orderDetails);
    },
    acceptOrder() {
      this.$emit("acceptOrder", this.orderDetails);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  gap: 10px;
  //background-color: rgb(20, 170, 100);
  background-color: #f1f1f1;
  border-radius: 8px;
  margin: 10px;
  min-height: 100px;
  //min-width: 90vw;
  padding-left: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  text-align: center;

  @media (min-width: 800px) {
    flex-direction: row;
    text-align: left;
  }

  .order-details {
    flex-basis: 50%;
  }

  .response {
    display: flex;
    gap: 20px;
    flex-basis: 50%;
    justify-content: space-around;

    @media (min-width: 800px) {
      justify-content: flex-end;
    }

    button {
      cursor: pointer;
    }

    .view-details-button {
      min-width: 150px;

      &:hover {
        background-color: rgb(50, 50, 50);
        transition: 0.25s;
      }
    }

    .accept-order-button {
      background-color: #30ce30;
      border: 2px solid #30ce30;
      min-width: 150px;

      &:hover {
        background-color: #62f062;
        transition: 0.25s;
      }
    }
  }
}
</style>
